module.exports = {
  no: "no",
  username: "username",
  email: "email",
  posts_count: "posts_count",
  trips_count: "trips_count",
};



// WEBPACK FOOTER //
// ./common/constants/clientSortTypes.js